export default {"src":"/_next/static/media/Web3Icon.da15f6a7.svg","height":70,"width":130};